// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__dsPy8","responsive":"styles_responsive__8H68X","collapsed":"styles_collapsed__ZwjHx"};